import { Table } from "antd";
import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNavReSeller from "../components/sidenavReSeller";

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, NavLink } from "react-router-dom";


const ViewReSellerArtworkDetails = () => {

    const { id } = useParams();
    const [productImages, setProductImages] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [styles, setStyles] = useState([]);

    const [productDetails, setProductDetails] = useState({
        productTitle: '', ownerName: '', artistName: '', category: '', description: '', price: '',
        originalPainting: '', newArrival: '', eliteChoice: '', affordableArt: '', priceOnDemand: '',
        negotiable: '', printingRights: '', featured: '', refundable: '', certificate: '',
        medium: '', surface: '', orientation: '', size: '', commission: '', packingMode: '',
        shippingTime: '', created_in: '', remark_to_indigalleria: '', remark_to_artist: '', tags: '',
        statusName: '', lockStatus: '', inventoryStatus: '', CreatedOn: '',

        // Additional fields as needed
    });

    // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        debugger;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        if (id) {
            fetchData(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkDetailsToViewByProductID?id=${id}`, setProductDetails);
            fetchData(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkImagesByProductID?id=${id}`, setProductImages);
            fetchData(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductSubjectListByProductID?id=${id}`, setSubjects);
            fetchData(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductStyleListByProductID?id=${id}`, setStyles);

        }
    }, [id, fetchData]);


    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNavReSeller />
                <div id="layoutSidenav_content">

                    <PageHeader name='Artwork Details' icon='bi bi-activity' />
                    {productDetails ? (
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4">
                                        <div className="card-header">Artwork Details</div>
                                        <div className="card-body">
                                            <NavLink className="btn btn-primary float-end" to={`/addArtworkReSeller/${id}/2`}><i className="bi bi-pencil-square"></i> Edit</NavLink>
                                            <NavLink className="btn btn-primary float-end" to={`/artworkReSellerAll`} style={{ marginRight: '10px' }}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                            <div className="clearfix"></div>
                                            <form>

                                                <div className="p-4 pt-2">
                                                    <div className="row">

                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork Title : </label>
                                                                <label>{productDetails.productTitle}</label>
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork ID : </label>
                                                                <label> IG{productDetails.id}</label>
                                                            </h5>
                                                        </div>

                                                    </div>
                                                    <div className="row">

                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artist : </label>
                                                                <label> {productDetails.artistName}</label>
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                                <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Owner : </label>
                                                                <label> {productDetails.ownerName}</label>
                                                            </h5>
                                                        </div>

                                                    </div>
                                                    <div className="viewTB">
                                                        <div className="viewtbcol">
                                                            <label>Category : </label>
                                                            <span>{productDetails.category}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Price : </label>
                                                            <span>{productDetails.price}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Medium : </label>
                                                            <span>{productDetails.medium}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Surface : </label>
                                                            <span>{productDetails.surface}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>New Arrival : </label>
                                                            <span>{productDetails.newArrival}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Original Painting : </label>
                                                            <span>{productDetails.originalPainting}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Elite Choice : </label>
                                                            <span>{productDetails.eliteChoice}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Affordable Art : </label>
                                                            <span>{productDetails.affordableArt}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Price On Demand : </label>
                                                            <span>{productDetails.priceOnDemand}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Negotiable : </label>
                                                            <span>{productDetails.negotiable}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Featured : </label>
                                                            <span>{productDetails.featured}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Printing Rights : </label>
                                                            <span>{productDetails.printingRights}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Certificate : </label>
                                                            <span>{productDetails.certificate}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Refundable : </label>
                                                            <span>{productDetails.refundable}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Oriantation : </label>
                                                            <span>{productDetails.orientation}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Size : </label>
                                                            <span>{productDetails.size}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Commission : </label>
                                                            <span>{productDetails.commission}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Creation Year : </label>
                                                            <span>{productDetails.created_in}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Packing Mode : </label>
                                                            <span>{productDetails.packingMode}</span>
                                                        </div>
                                                        <div className="viewtbcol">
                                                            <label>Shipping Time : </label>
                                                            <span>{productDetails.shippingTime}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-sm-12 form-group mb-3">
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Description : </label>
                                                            <div className="border w-100 p-2">
                                                                <label dangerouslySetInnerHTML={{ __html: productDetails.description }} />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Subjects:</label>
                                                            <ul className="border pt-2 pb-2">
                                                                {subjects.map(subjectList => (
                                                                    <li key={subjectList.id}>{subjectList.subject}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Styles:</label>
                                                            <ul className="border pt-2 pb-2">
                                                                {styles.map(styleList => (
                                                                    <li key={styleList.id}>{styleList.style}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="p-4 pt-2">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="horizontal-image-list">
                                                                {productImages.map((imageList, index) => (
                                                                    <img key={index} src={`../images/products/full/${imageList.image}`} alt={`Image ${index}`} className="w-100" />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>
                                        </div>




                                    </div>

                                </div>
                            </div>
                        </div>




                    ) : (
                        // Render a loading indicator or some placeholder while waiting for data
                        <div>Loading...</div>
                    )}

                    <Footer />
                </div>
            </div>
        </>
    );

};
export default ViewReSellerArtworkDetails